

export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_ERROR = "GET_ORDERS_ERROR";

export const VIEW_ORDER_SUCCESS = "VIEW_ORDER_SUCCESS";
export const VIEW_ORDER_ERROR = "VIEW_ORDER_ERROR";

// export const UPDATECATEGORY_SUCCESS = "UPDATECATEGORY_SUCCESS";
// export const UPDATECATEGORY_ERROR = "UPDATECATEGORY_ERROR";

// export const CHANGEACTION_SUCCESS = "CHANGEACTION_SUCCESS";
// export const CHANGEACTION_ERROR = "CHANGEACTION_ERROR";


